import React from 'react';
import Popup from 'reactjs-popup';

const NoteModal = ({ open, onClose, onSubmit, title, setTitle, body, setBody, submitting, error }) => (
  <Popup open={open} onClose={onClose} modal closeOnDocumentClick className="popup-modal">
    <form className="op-modal" onSubmit={onSubmit}>
      <h2 className="op-section-title">Edit note</h2>
      {error ? <p className="op-field op-print-error">{error}</p> : null}

      <label className="op-label" htmlFor="op-note-title">Title</label>
      <input
        id="op-note-title"
        className="op-input"
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <label className="op-label" htmlFor="op-note-body">Note</label>
      <textarea
        id="op-note-body"
        className="op-input op-textarea"
        rows={5}
        value={body}
        onChange={(e) => setBody(e.target.value)}
        required
      />

      <div className="op-modal-actions">
        <button type="button" className="op-btn" onClick={onClose} disabled={submitting}>Cancel</button>
        <button type="submit" className="op-btn op-btn-primary" disabled={!body.trim() || submitting}>
          {submitting ? 'Saving…' : 'Save note'}
        </button>
      </div>
    </form>
  </Popup>
);

export default NoteModal;
